/**
 * A US phone number written one way on the cards: 270-363-0516.
 *
 * A roster merged from several feeds (and the hand-added agents) carries the same kind of number
 * as 270-363-0516, (270) 543-0179 and +12705430179, so cards side by side read as two different
 * lists (Five Star Realty, 2026-10-29). Ten digits, or eleven starting with 1, are rewritten;
 * anything else (an extension, a non-US number, a short test value) is shown as typed.
 */
export function formatPhone(phone: string | null | undefined): string {
  const raw = (phone ?? '').trim();
  const digits = raw.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length !== 10 || /[a-z]/i.test(raw)) return raw;
  return `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}`;
}
